import { OutlinedInput, Stack, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

export const InputWithText = ({
  editMode,
  disabled,
  value,
  handleChange,
  blurHandler,
  sxConfig,
  rowData,
  maxLength = 8,
  id
}: {
  editMode: boolean;
  disabled: boolean;
  value: string;
  handleChange: (text: string) => void;
  blurHandler: (receivedValue: string) => void;
  sxConfig: SxProps<Theme>;
  rowData: any;
  maxLength?: number;
  id: string;
}) => {
  return (
    <>
      {editMode ? (
        <Stack id="input-with-text-container">
          <OutlinedInput
            data-testid="InputItemLabel"
            disabled={disabled}
            slotProps={{
              input: {
                style: { textAlign: "right" },
                "aria-label": "input",
                maxLength: maxLength
              }
            }}
            value={value}
            onChange={(event) => handleChange(event.target.value)}
            onBlur={(event) => blurHandler(event.target.value)}
            onFocus={(event) => event.target.select()}
            sx={{
              height: "36px",
              fontSize: "14px",
              width: "100%",
              ...sxConfig
            }}
          />
        </Stack>
      ) : (
        <Typography fontSize={14}>{rowData[id]}</Typography>
      )}
    </>
  );
};
